import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://innovation.valorizasm.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image-valoriza.jpg`;

/**
 * Reusable per-route SEO head manager.
 * Renders a unique <title>, meta description, canonical link, Open Graph / Twitter tags
 * and any JSON-LD structured data passed in `jsonLd`.
 */
export default function SEOHead({
  title,
  description,
  path = '/',
  ogType = 'website',
  ogImage = DEFAULT_OG_IMAGE,
  noindex = false,
  jsonLd = [],
  locale = 'es',
  alternates = [],
}) {
  const canonical = path === '/' ? SITE_URL : `${SITE_URL}${path}`;

  return (
    <Helmet>
      <html lang={locale} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="robots"
        content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'}
      />
      <link rel="canonical" href={canonical} />

      {alternates.map((a) => (
        <link key={a.hreflang} rel="alternate" hrefLang={a.hreflang} href={a.href.startsWith('http') ? a.href : `${SITE_URL}${a.href}`} />
      ))}

      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="Valoriza Innovation Hub" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={locale === 'en' ? 'en_US' : 'es_ES'} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}
